import { render, staticRenderFns } from "./Radar.vue?vue&type=template&id=2c054502&scoped=true&"
import script from "./Radar.vue?vue&type=script&lang=ts&"
export * from "./Radar.vue?vue&type=script&lang=ts&"
import style0 from "./Radar.vue?vue&type=style&index=0&id=2c054502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c054502",
  null
  
)

export default component.exports